"use client";

// src/dialog.tsx
import { cn } from "@momo/utils";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { XIcon } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogClose = DialogPrimitive.Close;
var DialogPortal = DialogPrimitive.Portal;
var DialogOverlay = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    DialogPrimitive.Overlay,
    {
      className: cn(
        "fixed inset-0 z-50 bg-black/40 backdrop-blur-sm",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
        className
      ),
      ...rest
    }
  );
};
var DialogContent = (props) => {
  const { className, children, ...rest } = props;
  return /* @__PURE__ */ jsxs(DialogPortal, { children: [
    /* @__PURE__ */ jsx(DialogOverlay, {}),
    /* @__PURE__ */ jsxs(
      DialogPrimitive.Content,
      {
        className: cn(
          "bg-background fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border p-6 shadow-lg",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]",
          className
        ),
        ...rest,
        children: [
          children,
          /* @__PURE__ */ jsxs(
            DialogPrimitive.Close,
            {
              className: cn(
                "ring-offset-background absolute right-4 top-4 rounded-sm opacity-70 transition-opacity",
                "hover:opacity-100",
                "focus:ring-ring focus:outline-none focus:ring-2 focus:ring-offset-2",
                "disabled:pointer-events-none",
                "data-[state=open]:bg-accent data-[state=open]:text-muted-foreground"
              ),
              children: [
                /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Close" }),
                /* @__PURE__ */ jsx(XIcon, { className: "size-4", "aria-hidden": "true" })
              ]
            }
          )
        ]
      }
    )
  ] });
};
var DialogHeader = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-1.5 text-center sm:text-left", className), ...rest });
};
var DialogFooter = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-2", className),
      ...rest
    }
  );
};
var DialogTitle = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    DialogPrimitive.Title,
    {
      className: cn("text-lg font-semibold leading-none tracking-tight", className),
      ...rest
    }
  );
};
var DialogDescription = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    DialogPrimitive.Description,
    {
      className: cn("text-muted-foreground text-sm", className),
      ...rest
    }
  );
};

export {
  Dialog,
  DialogTrigger,
  DialogClose,
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription
};
